import { z } from 'zod';

import { getCatalogItemsFromServer } from '~/features/catalog/controllers/get-catalog-items-from-server';

import skillToProgramsMapping from '../../../../skill-to-programs-mapping.json' assert { type: 'json' };

const skillMappingSchema = z.record(z.string());

// SkillNameToProgramPageMapping is a mapping of skill names to program page paths.
export type SkillNameToProgramPageMapping = z.infer<typeof skillMappingSchema>;

const parsedSkillToPrereqProgPage = skillMappingSchema.parse(skillToProgramsMapping);

const cache: Record<string, SkillNameToProgramPageMapping> = {};

/**
 * Takes a list of skill names and returns a mapping of skill names to course URLs. Does not include self-referential links.
 */
export function getPrereqsToCoursePages(skillNames: string[], programKey: string): SkillNameToProgramPageMapping {
  const cachedValue = cache[programKey];
  if (cachedValue) {
    return cachedValue;
  }
  const value = skillNames.reduce((acc, prereq) => {
    const targetProgramKey = parsedSkillToPrereqProgPage[prereq];
    if (targetProgramKey && programKey !== targetProgramKey) {
      const catalogItems = getCatalogItemsFromServer([targetProgramKey]);
      const slug = catalogItems[0]?.slug;
      if (slug) {
        acc[prereq] = `/course/${slug}`;
      }
    }
    return acc;
  }, {} as SkillNameToProgramPageMapping);
  cache[programKey] = value;
  return value;
}
